// @mui material components
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
// import DataTable from "examples/Tables/DataTable";
import DataTable from "../../../components/DataTable";
import { Skeleton } from "@mui/material";
import { ammTicketColumns } from "../utils";
const TicketTable = (props) => {
  const {
    title,
    ticketData,
    defaultValue,
    loading,
    icon,
    color,
    canDownloadCsv,
    topRightNode,
  } = props;
  return (
    <MDBox my={5}>
      <Card sx={{ width: "100%" }}>
        <MDBox display="flex" justifyContent="space-between">
          <MDBox display="flex">
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="4rem"
              height="4rem"
              variant="gradient"
              bgColor={color}
              color="light"
              shadow="md"
              borderRadius="xl"
              ml={3}
              mt={-2}
            >
              {icon}
            </MDBox>
            <MDTypography variant="h6" sx={{ mt: 2, mb: 1, ml: 2 }}>
              {title}
            </MDTypography>
          </MDBox>
          <MDBox sx={{ mt: 2, mb: 1, ml: 2, mr: 2 }}>{topRightNode}</MDBox>
        </MDBox>
        <MDBox p={2}>
          <Grid container>
            <Grid item xs={12}>
              {loading ? (
                <div>
                  <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                </div>
              ) : (
                <DataTable
                  table={ticketData}
                  canSearch
                  canDownloadCsv={canDownloadCsv}
                  entriesPerPage={{ defaultValue: defaultValue }}
                />
              )}
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </MDBox>
  );
};
export default TicketTable;
TicketTable.defaultProps = {
  title: "Tickets",
  topRightNode: <Grid item></Grid>,
  ticketData: { rows: [], columns: ammTicketColumns },
  defaultValue: 5,
  loading: true,
  color: "primary",
  canDownloadCsv: false,
  icon: <PlaylistAddCheckOutlinedIcon color="white" fontSize="large" />,
};
TicketTable.propTypes = {
  icon: PropTypes.node.isRequired,
  topRightNode: PropTypes.node,
  canDownloadCsv: PropTypes.bool,
};
